import React from "react";
import Dialog from "@mui/material/Dialog";
import promomatsPlaceholder from "../../images/placeholderPromomats.png";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import "./PromomatsPlaceholder.scss";
import config from "../../config/index";
export default function PromomatsPlaceholder({
  showNewBanner,
  setShowNewBanner,
}) {
  const handleGotoVeeva = () => {
    window.open(config.veevaUrl);
  };
  const closeNewBannerModal = (e) => {
    setShowNewBanner(false);
  };
  return (
    <>
      <Dialog
        open={showNewBanner}
        onClose={closeNewBannerModal}
        className="placeholder-container"
        aria-labelledby="form-dialog-title"
        overlaystyle={{ backgroundColor: "transparent" }}
      >
        <div className="placeholder-innercontainer">
          <div className="create-new-template-txt">To create a new Banner</div>
          <div className="create-new-template-txt2">
            First, create a Placeholder in PromoMats
          </div>
          <img
            className="promo-placeholder-img"
            height={181}
            width={308}
            src={promomatsPlaceholder}
          />
          <DialogActions className="modalActions templateBtn promomatsbtn">
            <Button
              type="submit"
              style={{
                fontFamily: "'Nunito Sans', sans-serif",
                //borderRadius: "0px",
              }}
              className="temp-btn"
              onClick={handleGotoVeeva}
            >
              {"GO TO PROMOMATS"}
            </Button>
            <Button
              onClick={closeNewBannerModal}
              color="primary"
              className="cancelBtntemp"
            >
              {"CLOSE"}
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    </>
  );
}
